import React,{ Component } from 'react';
import Charts from './Charts/Charts';
import ChartLine from './Charts/ChartLine';



class Home extends Component{
	
	render(){
		
		return(
		
		
			<div className="home">
				
				
				<div className="row">
						
						<div className="col-md-1">
							
						</div>
						<div className="col-md-5">
							<center><h4 className="titulo-graficos">Usuarios registrados los ultimos 3 meses</h4></center>
							<Charts/>
						</div>
						
						<div className="col-md-5">
							<center><h4 className="titulo-graficos">Viajes ultimos 3 meses</h4></center>
							<ChartLine/>
						</div>
												
						<div className="col-md-1">
							
						</div>
						
					
				</div>
				
				
					
			</div>
		
		);
		
		
	}
	
	
}


export default Home;


// WEBPACK FOOTER //
// ./src/Components/Home.jsx